<template src='./index.html'></template>
<script>
import { getdata } from './data.js';
import { dsrw_query } from '@/api/dsrw';
import { comMapping } from '@/components/util/Function/comMapping';

export default {
    name: 'dsrwmx',
    data: function() {
        return {
            searchdiag: false,
            filterSearchlist: [],
            searchlist: getdata().searchlist,
            searchdata: getdata().searchdata,
            pagination: getdata().pagination,
            headData: getdata().headData,
            tableData: [],
            tablekey: 0,
            overlength: 0,
            step: comMapping.$step,
            dwswType: comMapping.$dsrwType,
            zxzt: comMapping.$zxzt,
        };
    },
    mounted() {
    },
    created() {
        this.init();
    },
    methods: {
        formatStep(code) {
            return this.step.filter(x => code===x.value).map(x => x.label)[0];
        },
        formatDsrwType(code) {
            return this.dwswType.filter(x => code===x.value).map(x => x.label)[0];
        },
        formatZxzt(code) {
            return this.zxzt.filter(x => code===x.value).map(x => x.label)[0];
        },
        closeSearch() {
            this.searchdiag = false;
        },
        saveChange(e) {
            this.filterSearchlist = e;
            this.searchlist = e.filter(item => item.isshow);
            this.searchdiag = false;
        },
        forUpdateSearch() {
            this.filterSearchlist = JSON.parse(JSON.stringify(this.filterSearchlist.length ? this.filterSearchlist : this.searchlist));
            this.searchdiag = true;
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.taskInfoQuery();
        },
        geOoverLength(e) {
            this.overlength = e;
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.taskInfoQuery();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.taskInfoQuery();
        },
        forRefresh() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
        },
        confirmfilter(e) {
            this.headData = e.chooselist;
            this.outlist = e.nochooselist;
        },
        forback() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.taskInfoQuery();
            this.ywgzpg = false;
        },
        closediag() {
            this.ztdiag = false;
            this.taskInfoQuery();
        },
        //初始化
        init() {
            this.taskInfoQuery();
        },
        taskInfoQuery() {
            let params = JSON.parse(JSON.stringify(this.searchdata));
            params.current = this.pagination.pageNum;
            params.size = this.pagination.pageSize;
            params.sort = '';
            params.order = '';
            dsrw_query(params).then(res => {
                if (res.data.code !== "1") {
                    this.$message.error(res.data.msg);
                } else {
                    this.pagination.total = res.data.data.total;
                    this.tableData = res.data.data.records;
                }
            })
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
